/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PartitionFormat } from '../models/PartitionFormat';
import { PartitionSegmentType } from '../models/PartitionSegmentType';
import { SegmentType } from '../models/SegmentType';

export class PathSegment {
  'segmentType': SegmentType;
  /**
  * The literal string value (used when segmentType is STRING)
  */
  'segmentStringValue'?: string;
  'segmentPartitionType'?: PartitionSegmentType;
  'segmentPartitionFormat'?: PartitionFormat;
  /**
  * The partition column name (used when segmentType is PARTITION)
  */
  'segmentPartitionName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "segmentType",
      "baseName": "segmentType",
      "type": "SegmentType",
      "format": ""
    },
    {
      "name": "segmentStringValue",
      "baseName": "segmentStringValue",
      "type": "string",
      "format": ""
    },
    {
      "name": "segmentPartitionType",
      "baseName": "segmentPartitionType",
      "type": "PartitionSegmentType",
      "format": ""
    },
    {
      "name": "segmentPartitionFormat",
      "baseName": "segmentPartitionFormat",
      "type": "PartitionFormat",
      "format": ""
    },
    {
      "name": "segmentPartitionName",
      "baseName": "segmentPartitionName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PathSegment.attributeTypeMap;
  }

  public constructor() {
  }
}



